import { observable, computed } from 'mobx';

export class Advert {
  @observable public id: number;
  @observable public active: boolean;
  @observable public altText: string;
  @observable public slot: string;
  @observable public href: string;
  @observable public imageUrl: string;
  @observable public minWidth?: number;
  @observable public maxWidth?: number;
  @observable public startingAt?: Date;
  @observable public endingAt?: Date;

  constructor(
    id: number,
    altText: string,
    slot: string,
    href: string,
    imageUrl: string,
    active: boolean = true,
    minWidth?: number,
    maxWidth?: number,
    startingAt?: Date,
    endingAt?: Date
  ) {
    this.id = id;
    this.altText = altText;
    this.slot = slot;
    this.href = href;
    this.imageUrl = imageUrl;
    this.active = active;
    this.minWidth = minWidth;
    this.maxWidth = maxWidth;
    this.startingAt = startingAt;
    this.endingAt = endingAt;
  }

  @computed
  get mediaQuery(): string {
    const { minWidth, maxWidth } = this;
    const queries: Array<string> = [];

    if (minWidth) {
      queries.push(`(min-width: ${minWidth}px)`);
    }

    if (maxWidth) {
      queries.push(`(max-width: ${maxWidth}px)`);
    }

    return queries.join(' and ');
  }
}

export default Advert;



// WEBPACK FOOTER //
// ./src/app/models/Advert.ts